module.exports = __webpack_public_path__ + "images/96e74a1e.pay_12_kor.png";


//////////////////
// WEBPACK FOOTER
// ./images/baseintrov2/pay_12_kor.png
// module id = 582
// module chunks = 0